import { Skeleton } from "@/components/ui/skeleton";

const shimmerClassName = "from-gray-100 via-gray-200 to-gray-100";

const SidebarRequestLogCardShimmer = ({ animationDelayMs = 0 }: { animationDelayMs?: number }) => (
  <div
    aria-hidden="true"
    className="relative shrink-0 space-y-2 overflow-hidden rounded-md border border-gray-200 bg-white px-3.5 py-3 text-xs font-medium text-gray-500 duration-300 ease-out animate-in fade-in-0 slide-in-from-top-1"
    style={{
      height: 142,
      animationDelay: `${animationDelayMs}ms`,
      animationFillMode: "both",
    }}
  >
    <div className="flex h-4 max-w-[200px] items-center gap-2 overflow-hidden">
      <Skeleton className={shimmerClassName} width="112px" height="10px" borderRadius="3px" />
    </div>

    <div className="space-y-1">
      <div className="flex h-4 items-center gap-1.5">
        <Skeleton
          className={`${shimmerClassName} flex-shrink-0`}
          width="44px"
          height="8px"
          borderRadius="3px"
        />
        <Skeleton className={shimmerClassName} width="68%" height="8px" borderRadius="3px" />
      </div>
      <div className="flex h-4 items-center gap-1.5">
        <Skeleton
          className={`${shimmerClassName} flex-shrink-0`}
          width="56px"
          height="8px"
          borderRadius="3px"
        />
        <Skeleton className={shimmerClassName} width="58%" height="8px" borderRadius="3px" />
      </div>
    </div>

    <div className="flex h-5 items-center gap-1">
      <Skeleton className={shimmerClassName} width="40px" height="16px" borderRadius="2px" />
      <Skeleton className={shimmerClassName} width="48px" height="16px" borderRadius="2px" />
    </div>

    <div className="flex h-4 min-w-0 items-center justify-between gap-x-3">
      <div className="flex min-w-0 flex-grow items-center gap-1">
        <Skeleton
          className={`${shimmerClassName} flex-shrink-0`}
          width="12px"
          height="12px"
          borderRadius="3px"
        />
        <Skeleton className={shimmerClassName} width="80px" height="8px" borderRadius="3px" />
      </div>
      <Skeleton
        className={`${shimmerClassName} flex-shrink-0`}
        width="56px"
        height="8px"
        borderRadius="3px"
      />
    </div>
  </div>
);

export default SidebarRequestLogCardShimmer;
